!function (e, o) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define("platform-detect", o) : (e = e || self, e["platform-detect"] = o());
}(this, function () {
  "use strict";

  function e(e, o) {
    var n = window.matchMedia(e);
    o(n.matches);

    var i = function i() {
      return o(n.matches);
    };

    return n.addListener(i), function () {
      return n.removeListener(i);
    };
  }

  function o(e, o) {
    return t[e] !== o && (t[e] = o, s(e, o), !0);
  }

  var n = "undefined" != typeof navigator && "undefined" != typeof window;
  if (n && "undefined" != typeof nw) try {
    nw.Window.get();
  } catch (e) {
    n = !1;
  }
  var i = !n,
      r = n ? navigator.userAgent : void 0,
      t = {
    gui: n,
    terminal: i,
    registerQuery: e
  };
  t.node = "undefined" != typeof process && !!process.versions && !!process.versions.node, t.pwa = t.gui && window.matchMedia("(display-mode: standalone)").matches && null !== document.head.querySelector('[rel="manifest"]'), t.uwp = "undefined" != typeof Windows && "undefined" != typeof MSApp, t.nwjs = !(!t.node || !process.versions.nw), t.electron = !(!t.node || !process.versions.electron), t.cordova = !(!t.gui || !window.cordova), t.packaged = t.uwp || t.nwjs || t.electron || t.cordova, t.web = !t.node && !t.packaged, t.browser = t.web, t.website = t.web && !t.pwa, t.worker = !t.gui && "undefined" != typeof self && void 0 !== self.importScripts, t.serviceWorker = t.worker && !!navigator.serviceWorker.controller || !1, t.android = !!t.gui && r.includes("Android"), t.chromeos = !!t.gui && r.includes("CrOS"), t.tizen = !!t.gui && r.includes("Tizen"), t.ios = t.gui && /iPad|iPhone|iPod/.test(r) && !window.MSStream || !1, t.linuxBased = t.android || t.tizen, t.windows = t.node ? "win32" === process.platform : r.includes("Windows"), t.macos = t.node ? "darwin" === process.platform : r.includes("Macintosh"), t.linux = t.node ? "linux" === process.platform : r.includes("Linux") && !t.linuxBased && !t.macos, t.edgeHtml = t.gui && r.includes("Edge/"), t.edgeChromium = t.gui && r.includes("Edg/"), t.edgeAndroid = t.gui && r.includes("EdgA/"), t.edgeIos = t.gui && r.includes("EdgiOS/"), t.chromeIos = t.gui && r.includes("CriOS/"), t.firefoxIos = t.gui && r.includes("FxiOS/"), t.edge = t.edgeHtml || t.edgeChromium || t.edgeAndroid || t.edgeIos, t.samsungBrowser = t.gui && r.includes("SamsungBrowser/"), t.opera = t.gui && (r.includes("Opera") || r.includes("OPR/")), t.firefox = t.gui && (r.includes("Firefox") || t.firefoxIos), t.chrome = t.gui && (r.includes("Chrome") || t.chromeIos) && !t.edge && !t.opera && !t.samsungBrowser, t.safari = t.gui && r.includes("Safari") && !t.chrome && !t.edge && !t.firefox && !t.opera && !t.samsungBrowser || t.edgeIos || t.chromeIos || t.firefoxIos, t.ie = t.trident = t.gui && r.includes("Trident"), t.blink = t.chrome && !t.chromeIos || t.edgeChromium || t.edgeAndroid || t.samsungBrowser, t.webkit = t.blink || t.safari, t.gecko = t.firefox && !t.firefoxIos && !t.webkit && !t.safari;
  var d = {};
  t.on = function (e, o) {
    d[e] = d[e] || new Set(), d[e].add(o);
  }, t.off = t.removeListener = function (e, o) {
    d[e] && d[e].delete(o);
  };

  var s = t.emit = function (e, o) {
    d[e] && d[e].forEach(function (e) {
      return e(o);
    });
  };

  if (t.gui) {
    t.pixelRatio = parseFloat(window.devicePixelRatio.toFixed(2)), t.gameconsole = r.includes("Xbox") || r.includes("PlayStation");
    var a = 0;
    if (window.addEventListener("gamepadconnected", function (e) {
      return a++;
    }), window.addEventListener("gamepaddisconnected", function (e) {
      return a--;
    }), t.gameconsole) t.gamepad = !0, t.mouse = !0, t.touch = !1, t.tv = !0, t.battery = !1, t.phone = t.tablet = t.hybrid = t.laptop = t.desktop = !1, t.formfactor = "gameconsole";else {
      var c = function c() {
        o("tv", "tv" === t.formfactor), o("phone", "phone" === t.formfactor), o("tablet", "tablet" === t.formfactor), o("hybrid", "hybrid" === t.formfactor), o("laptop", "laptop" === t.formfactor), o("desktop", "desktop" === t.formfactor);
      },
          u = function u() {
        var e = Math.min(window.screen.width, window.screen.height);
        return t.tv ? "tv" : t.touch && e < 600 ? "phone" : t.touch && !t.mouse ? "tablet" : t.touch && t.mouse ? "hybrid" : t.battery ? "laptop" : "desktop";
      };

      t.touch = navigator.maxTouchPoints > 0, t.tv = r.includes("TV"), a = navigator.getGamepads ? Array.from(navigator.getGamepads()).filter(function (e) {
        return null !== e && void 0 !== e;
      }).length : 0, t.gamepad = a > 0, e("(orientation: portrait)", function (e) {
        t.portrait = e, t.landscape = !e, t.orientation = e ? "portrait" : "landscape", s("portrait", t.portrait), s("landscape", t.landscape), s("orientation", t.orientation);
      }), e("(any-pointer: coarse)", function (e) {
        o("touch", e), o("formfactor", u()) && c();
      }), e("(hover: hover)", function (e) {
        o("mouse", e), o("input", e ? "mouse" : "touch"), o("formfactor", u()) && c();
      });
    }
  }

  return t.csp = t.uwp || !1, t.nwjs ? t.dev = "sdk" === process.versions["nw-flavor"] : t.electron ? t.dev = process.execPath.replace(/\\/g, "/").includes("node_modules/electron/") : t.uwp ? t.dev = Windows.ApplicationModel.Package.current.isDevelopmentMode : t.node ? t.dev = "production" !== process.env.NODE_ENV : t.dev = void 0, t;
});